"use client";

import { useEffect, useState } from "react";
import { canLoadMarketingPixels } from "./nativeTracking";
import { PixelScripts } from "./PixelScripts";

export interface MarketingPixelsProps {
  metaPixelId: string;
  googleAnalyticsId: string;
  googleAdsId: string;
  tiktokPixelCode: string;
}

/**
 * Client component that gates marketing pixel loading behind consent.
 *
 * On native (Capacitor iOS / Android): pixels never load — the app is
 * declared as non-tracking in the iOS privacy manifest and we don't
 * present an ATT prompt. canLoadMarketingPixels() returns false.
 *
 * On web: gated by CookieScript consent via canTrackUser().
 *
 * PostHog is NOT included here — it stays in layout.tsx as product analytics.
 */
export function MarketingPixels(props: MarketingPixelsProps) {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      const result = await canLoadMarketingPixels();
      if (!cancelled) setAllowed(result);
    }

    check();
    return () => {
      cancelled = true;
    };
  }, []);

  if (allowed !== true) return null;

  return <PixelScripts {...props} />;
}
